import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface DiscountData {
  excludedClasses?: Array<string>;
  isActive: boolean;
  type: string;
  byStudent?: Record<string, number>;
  flat?: number;
  amountByStudent?: Record<string, number>;
  discounts?: Record<string, number>;
  discountRules: string;
  category: string;
}

const getDiscount = async (type: 'multi-student' | 'multi-class') => {
  const response = await baseAPI.get<DiscountData>(`/discount/${type}`);
  console.log(response);
  return response.data;
};

export const useGetDiscount = (type: 'multi-student' | 'multi-class') => {
  return useQuery({
    queryKey: [KEYS.DISCOUNT, type],
    queryFn: () => getDiscount(type),
  });
};
